'use strict';

import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { errorsSelectors, errorsOperations } from '@/state/domains/errors';

import s from './styles.scss';

const Errors = ({
	errors,
	removeError,
}) => {

	const toRemove = {};
	
	useEffect(() => {

		Object.entries(errors).forEach(([ uuid, e ]) => {
			if (!(uuid in toRemove)) {
				toRemove[ uuid ] = setTimeout(() => {
					removeError(uuid);
				}, 3000);
			}
		});

	}, [ errors ]);

	return (
		<div className={ s.errors }>
			{ Object.entries(errors).map(([ uuid, err ], i) => (
				<div key={ i }>
					{ err.message }
				</div>
			)) }
		</div>
	);
};

export default connect(
	(state, props) => ({
		errors: errorsSelectors.getErrors(state, props)
	}),
	{
		removeError: errorsOperations.removeError,
	}
)(Errors);
